var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestaoAssiduidade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gestao-assiduidade",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "129.4,134.1 121.4,134.1 121.4,71.3 113.2,79.6 113.2,134.1 105.3,134.1 105.3,87.5 97.1,95.7  97.1,134.1 89.1,134.1 89.1,108.5 80.9,100.3 80.9,134.1 73.3,134.1 73.3,92.6 70.5,89.7 65.1,95.2 65.1,134.1 57.3,134.1  57.3,103.4 49.1,111.6 49.1,134.1 41.2,134.1 41.2,108.2 70.4,78.2 81,88.8 81,88.8 86.8,94.6 137.9,43.5 132.2,37.7 86.8,83  76.1,72.3 76.1,72.3 74.5,70.7 70.7,66.9 70.6,66.9 70.3,66.6 41.2,96.5 41.2,37.6 33.1,37.6 33.1,142.3 33.9,142.3 33.9,142.3  137.6,142.3 137.6,138.2 137.6,138.2 137.6,55.2 129.4,63.4  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaoAssiduidade);
export default __webpack_public_path__ + "static/media/gestao-assiduidade.e18ec665d36701e32d8d378cec3cc1df.svg";
export { ForwardRef as ReactComponent };